<template>
  <v-container>
    <v-card max-width="1024" class="mx-auto mt-5">
      <v-card-title>
        <span class="text-h5">Ladda upp faktura poster från CSV</span>
      </v-card-title>
      <v-card-subtitle>
        Format: Magasin;Kundnummer;Produktgrupp;ArtikelId;Artikelnamn;Datum;AntalSålda;Pris;Moms;EdiReferens;Retur;Provision
        <em>Exempel: "Expressen;98417;Huvudtidning;EXP;EX Expressen;2026-07-24;35;38;6;1221;;21,5"</em>
      </v-card-subtitle>
      <v-card-text>
        <v-form ref="form">
          <v-file-input
            v-model="selectedFile"
            accept=".csv"
            label="Välj fil"
            prepend-icon="mdi-paperclip"
            show-size
            clearable
            :disabled="uploading"
            @change="handleFileChange"
          />

          <v-row class="mt-4">
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="newGrossPrice"
                label="Nytt Bruttopris (Valfritt)"
                type="number"
                step="0.01"
                min="0"
                outlined
                dense
                hint="Lämna tom för att behålla originalpris"
                persistent-hint
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model.number="newVat"
                label="Ny Moms (Valfritt)"
                type="number"
                step="0.01"
                min="0"
                outlined
                dense
                hint="Lämna tom för att behålla original moms"
                persistent-hint
              />
            </v-col>
          </v-row>

          <v-alert
            v-if="newGrossPrice || newVat"
            type="info"
            outlined
            class="mt-4"
          >
            <strong>Obs:</strong> Med prisanpassningar aktiverade kommer varje transaktion att dupliceras:
            <ul class="mt-2 mb-0">
              <li>Original: Negativt belopp (återkallelse)</li>
              <li>Ny: Positivt belopp med uppdaterat pris/moms</li>
            </ul>
          </v-alert>

          <v-alert
            v-if="message"
            :type="messageType"
            dismissible
            class="alert-message mt-4"
            @input="message = ''"
          >
            {{ message }}
          </v-alert>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="!selectedFile || uploading"
          :loading="uploading"
          @click="uploadFile"
        >
          <v-icon left>
            mdi-upload
          </v-icon>
          Ladda upp
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- Results card -->
    <v-card v-if="uploadedCount > 0" max-width="800" class="mx-auto mt-5">
      <v-card-title>
        <span class="text-h6">Uppladdningsresultat</span>
      </v-card-title>
      <v-card-text>
        <v-alert type="success" outlined>
          <strong>Framgång!</strong>
          <br>
          {{ uploadedCount }} transaktion{{ uploadedCount !== 1 ? 'er' : '' }} bearbetad{{ uploadedCount !== 1 ? 'e' : '' }}.
          <br>
          <span v-if="totalRecords > uploadedCount">
            Totalt {{ totalRecords }} poster bearbetade.
          </span>
        </v-alert>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import log from '@/logger'
import adminApi from '@/backend/adminapi'

export default {
  name: 'ExtraInvoiceUpload',
  data() {
    return {
      selectedFile: null,
      newGrossPrice: null,
      newVat: null,
      uploading: false,
      message: '',
      messageType: 'info',
      uploadedCount: 0,
      totalRecords: 0
    }
  },
  methods: {
    handleFileChange(file) {
      this.message = ''
      this.uploadedCount = 0
      this.totalRecords = 0
      this.selectedFile = file
    },
    async uploadFile() {
      if (!this.selectedFile) {
        this.message = 'Vänligen välj en fil först'
        this.messageType = 'warning'
        return
      }

      const formData = new FormData()
      formData.append('file', this.selectedFile)

      if (this.newGrossPrice !== null && this.newGrossPrice !== '') {
        formData.append('newGrossPrice', this.newGrossPrice)
      }

      if (this.newVat !== null && this.newVat !== '') {
        formData.append('newVat', this.newVat)
      }

      this.uploading = true
      this.message = ''

      adminApi.adminUploadExtraInvoice(formData)
        .then((resp) => {
          log.debug('Extra fakturor uppladdade framgångsrikt:', resp.data)
          this.uploadedCount = resp.data.extraInvoiceCount || 0
          this.totalRecords = resp.data.totalRecordsProcessed || 0
          this.message = resp.data.message || 'Framgång! Extra fakturor har bearbetats.'
          this.messageType = 'success'
          this.selectedFile = null
          this.newGrossPrice = null
          this.newVat = null
          this.$emit('extra-invoice-uploaded')
        })
        .catch((error) => {
          log.debug('Fel vid uppladdning av extra fakturor:', error)
          this.message = `Fel: ${error.message || 'Något gick fel vid uppladdning'}\n${error.response?.data?.message || ''}`
          this.messageType = 'error'
          this.uploadedCount = 0
          this.totalRecords = 0
        })
        .finally(() => {
          this.uploading = false
        })
    }
  }
}
</script>

<style scoped>
.alert-message {
  white-space: pre-wrap;
  word-wrap: break-word;
}

ul {
  padding-left: 1.5rem;
}
</style>
